export default "__VITE_ASSET__69295076__"